import Vue from 'vue';
import Amplify, * as AmplifyModules from 'aws-amplify';
import { AmplifyPlugin } from 'aws-amplify-vue';
import { Auth } from 'aws-amplify';
import App from './App.vue';
import router from './router';
import store from './store';
import awsExports from './aws-exports';
import './registerServiceWorker';

Amplify.configure(awsExports);

Vue.use(Auth);
Vue.use(AmplifyPlugin, AmplifyModules);

Vue.config.productionTip = false;

Vue.directive('longpress', {
  bind(el, binding) {
    let pressTimer = null;
    let startX = 0;
    let startY = 0;
    const moveThreshold = 10;

    const handler = (e) => {
      binding.value(e);
    };
    const start = (e) => {
      if (e.type === 'click' && e.button !== 0) return;
      const point = e.touches ? e.touches[0] : e;
      startX = point.clientX;
      startY = point.clientY;
      if (pressTimer === null) {
        pressTimer = setTimeout(() => {
          handler(e);
          pressTimer = null;
        }, 600);
      }
    };
    const cancel = () => {
      if (pressTimer !== null) {
        clearTimeout(pressTimer);
        pressTimer = null;
      }
    };
    const move = (e) => {
      if (pressTimer === null) return;
      const point = e.touches ? e.touches[0] : e;
      const dx = Math.abs(point.clientX - startX);
      const dy = Math.abs(point.clientY - startY);
      if (dx > moveThreshold || dy > moveThreshold) {
        cancel();
      }
    };

    el.addEventListener('mousedown', start);
    el.addEventListener('touchstart', start);
    el.addEventListener('mousemove', move);
    el.addEventListener('touchmove', move);
    el.addEventListener('mouseup', cancel);
    el.addEventListener('mouseleave', cancel);
    el.addEventListener('touchend', cancel);
    el.addEventListener('touchcancel', cancel);
  },
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
